import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1)
  },
  title: {
    display: 'block',
    fontWeight: 600
  },
  text: {
    display: 'block'
  }
}));

export default useStyles;
